import React from "react";
import { ROLE } from "Common/constants/roles";
import ProductionItemsPage from "Common/Components/ProductionItemsPage";

// کالاهای تحویل شده به مشتری = قلم‌هایی که item_status آن‌ها delivered است.
// آخرین مرحله‌ی گردش کالا؛ برگشت آن فقط برای ادمین مجاز است.
const Index = () => (
  <ProductionItemsPage
    pageTitle="کالاهای تحویل شده به مشتری"
    itemStatus="delivered"
    canRevert
    revertRoles={[]}
    emptyText="هیچ کالای تحویل‌شده‌ای نیست"
  />
);

export default Index;
